const columns = [
  {
    name: 'Sales (#)',
    key: 'TOTAL_SALES_CNT',
  },
  {
    name: 'Sales ($)',
    key: 'TOTAL_SALES_AMT',
    dollarFormat: true,
  },
  {
    name: 'Discounts (#)',
    key: 'TOTAL_DISCOUNTS_CNT',
  },
  {
    name: 'Discounts ($)',
    key: 'TOTAL_DISCOUNTS_AMT',
    dollarFormat: true,
  },
  {
    name: 'Deletes (#)',
    key: 'TOTAL_DELETES_CNT',
  },
  {
    name: 'Deletes ($)',
    key: 'TOTAL_DELETES_AMT',
    dollarFormat: true,
  },
  {
    name: 'Overrings (#)',
    key: 'TOTAL_OVERRINGS_CNT',
  },
  {
    name: 'Overrings ($)',
    key: 'TOTAL_OVERRINGS_AMT',
    dollarFormat: true,
  },
  {
    name: 'Payments (#)',
    key: 'TOTAL_PAYMENTS_CNT',
  },
  {
    name: 'Payments ($)',
    key: 'TOTAL_PAYMENTS_AMT',
    dollarFormat: true,
  },
];

export default columns;